import { Controller } from "stimulus";

export default class extends Controller {

    editAction() {
        this.publishVoucherConfirmedEvent(false);
    }

    confirmAction() {
        this.publishVoucherConfirmedEvent(true);
    }

    publishVoucherConfirmedEvent(confirmed) {
        const event = document.createEvent("CustomEvent");
        event.initCustomEvent("voucher-confirmed", true, true, null);
        event.confirmed = confirmed;
        this.element.dispatchEvent(event);
    }
}
